/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Api_Errors_Invalid_FileInputs */

const nl_import_api_errors_invalid_file = /** @type {(inputs: Import_Api_Errors_Invalid_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het bestand kon niet gelezen worden. Gebruik een geldig Excel-bestand (.xlsx)`)
};

/**

* @param {Import_Api_Errors_Invalid_FileInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const import_api_errors_invalid_file = /** @type {((inputs?: Import_Api_Errors_Invalid_FileInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Api_Errors_Invalid_FileInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_import_api_errors_invalid_file(inputs)
});
export { import_api_errors_invalid_file as "import.api_errors.invalid_file" }